export const activeUsers = [
  { id: 1, name: "수아",  avatar: "https://public.readdy.ai/ai/img_res/613c5228a397d2c479287f7966bef66f.jpg", isOnline: true },
  { id: 2, name: "민준",  avatar: "https://readdy.ai/api/search-image?query=young%20korean%20male%20smiling%20bright%20portrait%20clean%20white%20background%20minimal%20headshot%20photography&width=60&height=60&seq=cu2&orientation=squarish", isOnline: true },
  { id: 3, name: "지수",  avatar: "https://readdy.ai/api/search-image?query=young%20korean%20female%20casual%20portrait%20bright%20clean%20background%20minimal%20photography%20headshot&width=60&height=60&seq=cu3&orientation=squarish", isOnline: true },
  { id: 4, name: "도현",  avatar: "https://readdy.ai/api/search-image?query=young%20korean%20male%20casual%20portrait%20bright%20clean%20background%20minimal%20photography%20headshot&width=60&height=60&seq=cu4&orientation=squarish", isOnline: false },
  { id: 5, name: "예린",  avatar: "https://readdy.ai/api/search-image?query=young%20korean%20female%20smiling%20portrait%20bright%20clean%20background%20minimal%20photography%20headshot%20warm&width=60&height=60&seq=cu5&orientation=squarish", isOnline: true },
  { id: 6, name: "우진",  avatar: "https://readdy.ai/api/search-image?query=young%20korean%20male%20smiling%20portrait%20bright%20clean%20background%20minimal%20photography%20headshot%20warm&width=60&height=60&seq=cu6&orientation=squarish", isOnline: true },
  { id: 7, name: "민서",  avatar: "https://readdy.ai/api/search-image?query=young%20korean%20female%20casual%20smiling%20portrait%20clean%20background%20minimal%20photography%20headshot%20studio&width=60&height=60&seq=cu7&orientation=squarish", isOnline: false },
  { id: 8, name: "재원",  avatar: "https://readdy.ai/api/search-image?query=young%20korean%20male%20casual%20smiling%20portrait%20clean%20background%20minimal%20photography%20headshot%20studio&width=60&height=60&seq=cu8&orientation=squarish", isOnline: true },
];

export interface FeedPost {
  id: number;
  user: { name: string; avatar: string };
  type: "image" | "stamp" | "text" | "fail";
  content: string;
  image: string | null;
  stamp: string | null;
  claps: number;
  fire: number;
  spark: number;
  time: string;
  height: "tall" | "medium" | "short";
  failPrompt?: string;
  failReason?: string;
  failQuestion?: string;
}

export const feedPosts: FeedPost[] = [
  {
    id: 1,
    user: { name: "김수아", avatar: "https://readdy.ai/api/search-image?query=young%20korean%20female%20smiling%20bright%20portrait%20clean%20white%20background%20minimal%20headshot%20photography&width=40&height=40&seq=fp1&orientation=squarish" },
    type: "image",
    content: "미드저니 이모티콘 24개 완성 🎨 카카오 이모티콘 심사 제출 완료! 승인되면 바로 수익 인증 올릴게요",
    image: "https://readdy.ai/api/search-image?query=cute%20kawaii%20sticker%20emoticon%20character%20set%20design%20AI%20generated%20colorful%20pastel%20tones%20flat%20art%20white%20background%20collection&width=400&height=500&seq=fp1img&orientation=portrait",
    stamp: null, claps: 24, fire: 8, spark: 15, time: "방금 전", height: "tall",
  },
  {
    id: 2,
    user: { name: "이민준", avatar: "https://readdy.ai/api/search-image?query=young%20korean%20male%20smiling%20bright%20portrait%20clean%20white%20background%20minimal%20headshot%20photography&width=40&height=40&seq=fp2&orientation=squarish" },
    type: "stamp",
    content: "💸 AI 자동화 챌린지 14일 완주! 이번 달 야근 0회 달성. 절약된 시간으로 부업 준비 시작합니다",
    image: null, stamp: "✅", claps: 41, fire: 19, spark: 22, time: "5분 전", height: "short",
  },
  {
    id: 3,
    user: { name: "강다은", avatar: "https://readdy.ai/api/search-image?query=young%20korean%20female%20casual%20portrait%20clean%20bright%20background%20minimal%20photography%20headshot&width=40&height=40&seq=fp3b&orientation=squarish" },
    type: "fail",
    content: "이모티콘에 브랜드 이름 텍스트 넣으려다 완전 망함 ㅋㅋ AI가 텍스트를 이상하게 그리는데 해결방법 있으신 분?",
    image: "https://readdy.ai/api/search-image?query=AI%20generated%20image%20distorted%20weird%20text%20artifacts%20glitch%20digital%20error%20pattern%20colorful%20abstract&width=400&height=320&seq=fp3fail&orientation=landscape",
    stamp: null,
    failPrompt: "cute character sticker design, with brand name 달봄 written on it, white background, kawaii --v 6",
    failReason: "AI는 텍스트 렌더링이 취약해요. 텍스트 포함 요청 시 환각 현상 발생",
    failQuestion: "텍스트 없이 브랜드 느낌만 살리는 방법 아시는 분?",
    claps: 12, fire: 5, spark: 38, time: "12분 전", height: "medium",
  },
  {
    id: 4,
    user: { name: "박지수", avatar: "https://readdy.ai/api/search-image?query=young%20korean%20female%20casual%20portrait%20bright%20clean%20background%20minimal%20photography%20headshot&width=40&height=40&seq=fp3&orientation=squarish" },
    type: "image",
    content: "💸 수익 인증! AI 쇼츠 스크립트 챌린지 후 유튜브 쇼츠 조회수 11만 돌파 → 수익화 조건 달성 🎉",
    image: "https://readdy.ai/api/search-image?query=youtube%20analytics%20dashboard%20screen%20showing%20high%20views%20monetization%20milestone%20success%20celebration%20phone%20creator%20studio%20warm%20minimal&width=400&height=300&seq=fp3img&orientation=landscape",
    stamp: null, claps: 67, fire: 34, spark: 45, time: "20분 전", height: "medium",
  },
  {
    id: 5,
    user: { name: "최도현", avatar: "https://readdy.ai/api/search-image?query=young%20korean%20male%20casual%20portrait%20bright%20clean%20background%20minimal%20photography%20headshot%20warm&width=40&height=40&seq=fp4&orientation=squarish" },
    type: "fail",
    content: "ChatGPT 보고서 자동화 프롬프트 짰는데 너무 길고 딱딱하게 나와요. 짧고 실용적으로 뽑는 분 힌트 주세요",
    image: null, stamp: null,
    failPrompt: "Act as a report writer. Write a weekly business report about marketing team activities.",
    failReason: "역할만 지정하고 출력 형식/길이 명시 안 하면 너무 일반적인 결과 출력",
    failQuestion: "\"200단어 이내, 불릿 리스트\" 같은 제약 조건 추가해봤나요?",
    claps: 18, fire: 9, spark: 52, time: "31분 전", height: "short",
  },
  {
    id: 6,
    user: { name: "한예린", avatar: "https://readdy.ai/api/search-image?query=young%20korean%20female%20smiling%20portrait%20bright%20clean%20background%20minimal%20photography%20headshot%20warm&width=40&height=40&seq=fp5&orientation=squarish" },
    type: "image",
    content: "💰 월 수익 인증! AI 카피라이팅 외주 2건 수주 → 이번 달 부업 수익 +67만원 달성 🎉 이 프롬프트 공유합니다",
    image: "https://readdy.ai/api/search-image?query=person%20celebrating%20laptop%20screen%20showing%20income%20revenue%20earnings%20transfer%20bank%20notification%20success%20minimal%20clean%20background%20warm%20light&width=400&height=450&seq=fp5img&orientation=portrait",
    stamp: null, claps: 89, fire: 52, spark: 61, time: "1시간 전", height: "tall",
  },
  {
    id: 7,
    user: { name: "정우진", avatar: "https://readdy.ai/api/search-image?query=young%20korean%20male%20smiling%20portrait%20bright%20clean%20background%20minimal%20photography%20headshot%20warm&width=40&height=40&seq=fp6&orientation=squarish" },
    type: "stamp",
    content: "⏰ 칼퇴 7일 연속 달성! 이번 달 절약된 시간 14시간. 그 시간으로 GPT SaaS 기획 중 🚀",
    image: null, stamp: "🏅", claps: 55, fire: 27, spark: 33, time: "2시간 전", height: "short",
  },
];
